// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-container[data-v-1021514d]{background:linear-gradient(#222,#000);height:500px;padding-bottom:115px;position:fixed;top:0;width:100vw}@media screen and (max-width:1264px){.title-container[data-v-1021514d]{margin-bottom:80px}}.title-container.open-sidebar[data-v-1021514d]{width:calc(100vw - 333px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
